import { Category } from "@/types/category";
import { APIClient } from "@/utils/httpClient";
import { getRouter } from "@/utils/routerRef";
import { defineStore } from "pinia";
import { authStore } from "./authStore";

interface ICategoryStoreState {
	categories: Array<Category>;
}

export const categoryStore = defineStore("categoryStore", {
	persist: false,
	state: () =>
		({
			categories: [],
		} as ICategoryStoreState),
	getters: {
		getItems(state: ICategoryStoreState) {
			return state.categories;
		},
		getItemByID:
			(state: ICategoryStoreState) =>
			(id: string): Category | undefined => {
				return state.categories.find((e: Category) => e.id == id);
			},
	},
	actions: {
		addItems(items: Category[]): void {
			this.categories = items;
		},
		async getItemCategories() {
			const authState = authStore();
			const campaignId = authState.campaignId;
			const endpoint = `/campaigns/${campaignId}/categories`;
			try {
				const response = await APIClient.get(endpoint);
				if (response.success) {
					this.categories = response.data;
				} else {
					if (
						response.data &&
						response.data.status &&
						response.data.status == "CAMPAIGN-ENDED"
					) {
						getRouter().replace(`/${campaignId}/campaign-over`);
					} else if (
						response.data &&
						response.data.status &&
						response.data.status == "CAMPAIGN-PAUSED"
					) {
						getRouter().replace(`/${campaignId}/campaign-paused`);
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
	},
});
